import React from 'react'
import bg from '../../../public/static/image-background/logo-v-02.png'
import config from '../../../constants/config'
import { getBase64, formatDateTime, useTranslation } from '../../../constants/helpers'
import { useSearchParams } from 'react-router-dom'

const PlayersList9 = ({ id, players, league, size, setIsReady, isShowBirthDay, seasonData, teamData, checkboxPlayer, checkboxStaff, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = width / 100
    const sizeItemLogo = px * 15
    const [listUser, setListUser] = React.useState([])

    const color = {
        first: '#00e5ff',    // Neon Cyan
        second: '#00b4d8',   // Ocean Blue
        third: '#90e0ef',    // Light Cyan
        fourth: '#caf0f8',   // Ice Blue
        text: '#ffffff',
        subText: 'rgba(202,240,248,0.8)',
        bg: '#030816',       // Deep Dark Navy
        staffBorder: '#00e5ff',
        playerBorder: '#00b4d8'
    }

    const listPlayer = players?.reduce(
        (p, c) => {
            if (!p[c.types]) p[c.types] = []
            if (c.types?.length > 1) {
                p['football_player_type'].push(c)
                p['football_staff_type'].push(c)
                return p
            }
            p[c.types].push(c)
            return p
        },
        { football_player_type: [], football_staff_type: [] }
    )

    const arrPriority = ['football_team_manager', 'football_coach', 'football_coach_assistant', 'football_medical_staff', 'football_marketing', 'football_other_staff']
    const maxSortIndex = arrPriority?.length
    const _staffs = listPlayer?.football_staff_type
        ?.map(item => {
            const positions = item?.positions
                ?.map(i => {
                    const sortIndex = arrPriority.findIndex(p => p == i)
                    return { value: i, sortIndex: sortIndex == -1 ? maxSortIndex : sortIndex }
                })
                .sort((a, b) => a.sortIndex - b.sortIndex)
                ?.map(p => p.value)
            const sortIndex = arrPriority?.findIndex(p => p == positions[0])
            return { ...item, positions, sortIndex: sortIndex == -1 ? maxSortIndex : sortIndex }
        })
        .sort((a, b) => a.sortIndex - b.sortIndex)

    const onLoaded = value => {
        setListUser(s => [...s, value])
    }

    React.useEffect(() => {
        if (listUser?.length === listPlayer?.football_staff_type?.length + listPlayer.football_player_type?.length) {
            setIsReady?.(true)
        }
    }, [listUser])

    const staffPosition = {
        football_coach: t('football_coach'),
        football_coach_assistant: t('football_coach_assistant'),
        football_marketing: t('football_marketing'),
        football_medical_staff: t('football_medical_staff'),
        football_other_staff: t('football_other_staff'),
        football_team_manager: t('football_team_manager')
    }

    const itempx = (width - 10 * px) / 100

    return (
        <div
            id={id}
            style={{
                backgroundColor: color.bg,
                width: width,
                paddingBottom: isShowSponsor && sponsorData?.length > 0 ? px * 10 : px * 3,
                position: 'relative',
                overflow: 'hidden',
                fontFamily: 'SFUHelveticaCondensedBold'
            }}
        >
            {/* Grid background */}
            <div style={{
                position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0,
                backgroundImage: `linear-gradient(rgba(0,229,255,0.025) 1px, transparent 1px), linear-gradient(90deg, rgba(0,229,255,0.025) 1px, transparent 1px)`,
                backgroundSize: `${px * 5}px ${px * 5}px`
            }} />
            {/* Radial glow */}
            <div style={{ position: 'absolute', top: '20%', left: '50%', transform: 'translate(-50%, -50%)', width: `${px * 120}px`, height: `${px * 80}px`, background: 'radial-gradient(ellipse, rgba(0,180,216,0.08) 0%, transparent 70%)', zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1, padding: `${px * 2}px ${px * 2}px 0` }}>

                {/* ========== HEADER ========== */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: `${px * 1.5}px` }}>
                    {/* Left: team logo + name */}
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
                        <Image src={teamData?.logo} style={{ width: `${sizeItemLogo * 0.8}px`, height: `${sizeItemLogo * 0.8}px`, objectFit: 'contain', filter: `drop-shadow(0 0 ${px * 0.8}px rgba(0,229,255,0.8))`, borderRadius: '50%' }} />
                        <p style={{ color: color.first, fontSize: `${px * 1.8}px`, textTransform: 'uppercase', textAlign: 'center', marginTop: `${px * 0.5}px`, fontWeight: 'bold', textShadow: `0 0 8px ${color.first}` }}>{teamData?.name}</p>
                    </div>

                    {/* Center: league logo + title + team */}
                    <div style={{ flex: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <Image src={seasonData?.logo} style={{ width: `${sizeItemLogo * 0.9}px`, height: `${sizeItemLogo * 0.9}px`, objectFit: 'contain', filter: `drop-shadow(0 0 ${px}px rgba(0,229,255,0.7))` }} />
                        <h1 style={{ color: color.first, fontSize: `${px * 4}px`, textTransform: 'uppercase', textAlign: 'center', margin: `${px * 0.5}px 0`, textShadow: `0 0 15px ${color.first}, 0 0 30px ${color.second}`, fontWeight: 'bold', letterSpacing: `${px * 0.1}px` }}>
                            {t('list_team_member')}
                        </h1>
                        <h2 style={{ color: color.text, fontSize: `${px * 2.4}px`, textTransform: 'uppercase', textAlign: 'center', margin: 0, fontWeight: 'bold' }}>{teamData?.name}</h2>
                    </div>

                    {/* Right: vsports logo + season info */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Image src={bg} style={{ width: `${sizeItemLogo * 0.7}px`, objectFit: 'contain', filter: `drop-shadow(0 0 4px rgba(0,229,255,0.4))` }} />
                        <p style={{ color: color.third, fontSize: `${px * 1.5}px`, textTransform: 'uppercase', textAlign: 'center', marginTop: `${px * 0.5}px` }}>{seasonData?.name}</p>
                    </div>
                </div>

                {/* Cyan divider */}
                <div style={{ width: '100%', height: `${px * 0.3}px`, background: `linear-gradient(90deg, transparent, ${color.first}, transparent)`, marginBottom: `${px * 2}px` }} />

                {/* ========== STAFF ========== */}
                {listPlayer?.football_staff_type?.length > 0 && checkboxStaff && (
                    <div style={{ marginBottom: `${px * 2}px` }}>
                        {/* Section label */}
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: `${px * 1.5}px` }}>
                            <div style={{ width: `${px * 0.5}px`, height: `${px * 3}px`, background: color.first, marginRight: `${px}px`, boxShadow: `0 0 8px ${color.first}` }} />
                            <h2 style={{ color: color.first, fontSize: `${px * 2.5}px`, textTransform: 'uppercase', margin: 0, textShadow: `0 0 10px ${color.first}`, letterSpacing: '1px' }}>{t('staff')}</h2>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                            {_staffs?.map((i, idx) => (
                                <div key={`${idx}+${i.id}`} style={{ display: 'flex', width: `${((19.5 * itempx) / 50) * 40}px`, marginTop: `${((1.5 * itempx) / 50) * 40}px`, marginBottom: `${((1 * itempx) / 50) * 40}px`, alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
                                    <div style={{ position: 'relative' }}>
                                        <Image onLoad={onLoaded} src={i.avatar || config.logo} style={{
                                            width: `${((23 * itempx) / 100) * 38}px`,
                                            height: `${((23 * itempx) / 100) * 38}px`,
                                            border: `${px * 0.3}px solid ${color.staffBorder}`,
                                            backgroundColor: 'rgba(3,8,30,0.8)',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            boxShadow: `0 0 12px rgba(0,229,255,0.5)`
                                        }} />
                                    </div>
                                    <h3 style={{ marginTop: `${px * 0.5}px`, color: color.first, fontSize: `${itempx * 2}px`, textTransform: 'uppercase', textAlign: 'center' }}>{staffPosition[i.positions[0]] || i?.positions[0]}</h3>
                                    <h3 style={{ color: color.text, paddingLeft: '2px', paddingRight: '2px', fontSize: i.name?.length > 14 ? `calc(${width / (i.name?.length * 7)}pt)` : `${itempx * 1.3}px`, width: '100%', textAlign: 'center', textTransform: 'uppercase', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{i.name}</h3>
                                    {isShowBirthDay && <h3 style={{ color: color.subText, fontSize: `${itempx * 1.7}px`, textAlign: 'center', textTransform: 'uppercase' }}>{formatDateTime(i.birthday, 'date')}</h3>}
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Divider between sections */}
                {listPlayer?.football_staff_type?.length > 0 && checkboxStaff && listPlayer?.football_player_type?.length > 0 && checkboxPlayer && (
                    <div style={{ width: '90%', height: `${px * 0.15}px`, background: `linear-gradient(90deg, transparent, rgba(0,229,255,0.3), transparent)`, margin: `0 auto ${px * 1.5}px` }} />
                )}

                {/* ========== PLAYERS ========== */}
                {listPlayer?.football_player_type?.length > 0 && checkboxPlayer && (
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', marginBottom: `${px * 1.5}px` }}>
                            <div style={{ width: `${px * 0.5}px`, height: `${px * 3}px`, background: color.second, marginRight: `${px}px`, boxShadow: `0 0 8px ${color.second}` }} />
                            <h2 style={{ color: color.second, fontSize: `${px * 2.5}px`, textTransform: 'uppercase', margin: 0, textShadow: `0 0 10px ${color.second}`, letterSpacing: '1px' }}>{t('player')}</h2>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                            {listPlayer?.football_player_type?.map((i, idx) => (
                                <div key={`${idx}+${i.id}`} style={{ display: 'flex', width: `${((19.5 * itempx) / 50) * 40}px`, marginTop: (listPlayer?.football_staff_type?.length < 1 || !listPlayer?.football_staff_type) && idx < 7 ? `${((4 * itempx) / 50) * 100}px` : `${((1 * itempx) / 50) * 40}px`, marginBottom: `${((1 * itempx) / 50) * 40}px`, alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
                                    <div style={{ position: 'relative' }}>
                                        <Image onLoad={onLoaded} src={i.avatar || config.logo} style={{
                                            width: `${((23 * itempx) / 100) * 38}px`,
                                            height: `${((23 * itempx) / 100) * 38}px`,
                                            border: `${px * 0.3}px solid ${color.playerBorder}`,
                                            backgroundColor: 'rgba(3,8,30,0.8)',
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                            boxShadow: `0 0 10px rgba(0,180,216,0.5)`
                                        }} />
                                        {/* Shirt number badge */}
                                        {i.shirtNumber != null && (
                                            <div style={{ position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)', background: `linear-gradient(135deg, ${color.second}, ${color.first})`, borderRadius: `${px * 0.5}px`, padding: `${px * 0.1}px ${px * 0.4}px`, minWidth: `${px * 2.5}px`, textAlign: 'center' }}>
                                                <span style={{ color: '#030816', fontSize: `${itempx * 1.8}px`, fontWeight: 'bold', fontFamily: 'SFUHelveticaCondensedBold' }}>{i.shirtNumber}</span>
                                            </div>
                                        )}
                                    </div>
                                    <div style={{ height: `${((12 * itempx) / 100) * 40}px`, width: `${((18.5 * itempx) / 50) * 40}px` }}>
                                        <h3 style={{ color: color.text, paddingLeft: '2px', paddingRight: '2px', fontSize: i.name.length > 14 ? `calc(${width / (i.name.length * 7)}pt)` : `${itempx * 1.3}px`, width: '100%', textAlign: 'center', textTransform: 'uppercase', fontWeight: 'bold', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{i.name}</h3>
                                        {isShowBirthDay && <h3 style={{ color: color.subText, fontSize: `${itempx * 1.7}px`, textAlign: 'center', textTransform: 'uppercase' }}>{formatDateTime(i.birthday, 'date')}</h3>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* ========== SPONSOR BAR ========== */}
            {isShowSponsor && sponsorData?.length > 0 && (
                <div style={{
                    height: `${8 * px}px`,
                    width: '100%',
                    position: 'absolute',
                    bottom: `${px * 0.5}px`,
                    padding: `${0.8 * px}px 0px`,
                    background: `linear-gradient(90deg, rgba(0,119,182,0.3), rgba(0,180,216,0.2), rgba(0,119,182,0.3))`,
                    border: `${px * 0.1}px solid rgba(0,229,255,0.3)`,
                    zIndex: 2
                }}>
                    <div style={{ width: '95%', height: '100%', backgroundColor: 'rgba(3,8,30,0.8)', margin: '0 auto', borderRadius: `${3 * px}px`, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', border: `${px * 0.1}px solid rgba(0,229,255,0.2)` }}>
                        {sponsorData?.length > 0 && sponsorData?.slice(0, 10)?.map((i, idx) => (
                            <Image key={idx} src={i.logo || config.logo} style={{ width: 'auto', maxHeight: `${px * 5}px`, backgroundColor: 'white', objectFit: 'cover', marginRight: `${2 * px}px`, borderRadius: `${px * 0.5}px` }} />
                        ))}
                    </div>
                </div>
            )}

            {/* Footer text */}
            <p style={{ position: 'relative', zIndex: 1, textAlign: 'right', color: 'rgba(202,240,248,0.4)', fontSize: `${px * 1.5}px`, margin: `${px * 1}px ${px * 2}px 0`, fontWeight: 'bold' }}>
                {window.sessionStorage.getItem('HomeUrl') || 'VSPORT EXCLUSIVE'}
            </p>
        </div>
    )
}

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props?.src?.includes('ui-avatars')) {
            getBase64(config.logo).then(r => setData(r))
        } else {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return data ? <img {...props} src={data} onLoad={props.onLoad} alt="" /> : null
}

const areEqual = (p, n) => {
    return (
        JSON.stringify(p.players) === JSON.stringify(n.players) &&
        JSON.stringify(p.checkboxPlayer) === JSON.stringify(n.checkboxPlayer) &&
        JSON.stringify(p.checkboxStaff) === JSON.stringify(n.checkboxStaff) &&
        JSON.stringify(p.isShowBirthDay) === JSON.stringify(n.isShowBirthDay) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
    )
}

export default React.memo(PlayersList9, areEqual)
